<script setup lang="ts" generic="T extends ContentGroupItem = ContentGroupItem">
  import ContentAttribution from '../../atoms/ContentAttribution/ContentAttribution.vue'
  import ContentTitle from '../../atoms/ContentTitle/ContentTitle.vue'
  import Typography from '../../atoms/Typography/Typography.vue'
  import type { ContentGroupItem } from './types'

  withDefaults(
    defineProps<{
      heading?: string
      headingIcon?: string
      items: T[]
    }>(),
    {
      heading: 'Related Stories',
      headingIcon: 'i-heroicons-newspaper',
      items: () => [],
    }
  )

  defineSlots<{
    item?: (props: { item: T; index: number }) => unknown
  }>()
</script>

<template>
  <!-- Slots: named #item slot per list item -->
  <section
    class="h-full w-full overflow-hidden rounded-lg border border-border-subtle bg-surface-primary shadow-article-card"
  >
    <!-- Header -->
    <div class="flex items-center gap-2 px-4 py-3">
      <UIcon
        v-if="headingIcon"
        :name="headingIcon"
        class="h-4 w-4 shrink-0 text-content-secondary"
      />
      <Typography
        element="h2"
        variant="text-base"
        weight="font-semibold"
        color="text-content-primary"
      >
        {{ heading }}
      </Typography>
    </div>

    <!-- Item list -->
    <ul class="flex flex-col">
      <li
        v-for="(item, index) in items"
        :key="item.id"
        class="flex flex-col gap-1 px-4 py-3"
      >
        <slot name="item" :item="item" :index="index">
          <ContentAttribution
            :source-name="item.sourceName"
            :source-icon-url="item.sourceIconUrl"
            :time="item.time"
          />
          <ContentTitle
            :text="item.title"
            size="text-sm"
            weight="font-semibold"
            classes="text-content-primary"
            :max-lines="3"
          />
        </slot>
      </li>
    </ul>
  </section>
</template>
